import { orderListRoute } from "./order.list";
export const orderRoutes = {
  path: "/order",
  redirect: "/order/list",
  component: () => import("../views/order.vue"),
  children: [{ ...orderListRoute }],
};
